import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { CodeBlock } from '../components/CodeBlock';
import { Reveal } from '../components/Reveal';

const TOOLS = [
  { name: 'draft_email', desc: 'Generate a new HTML email from a prompt.' },
  { name: 'modify_email', desc: 'Edit an existing draft with natural language.' },
  { name: 'screenshot_email', desc: 'Render a draft to PNG so the agent can "see" it.' },
  { name: 'send_email', desc: 'Send to any list, from any verified domain.' },
  { name: 'list_drafts', desc: "List the user's drafts the agent has created." },
];

const MCP_SNIPPET = `{
  "mcpServers": {
    "sendfast": {
      "url": "https://sendfast.ai/api/mcp",
      "headers": {
        "Authorization": "Bearer sf_live_..."
      }
    }
  }
}`;

export function ForAgents() {
  return (
    <section id="for-agents" className="border-border bg-muted/60 border-y py-24 lg:py-32">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <Reveal>
          <p className="text-muted-foreground text-xs uppercase tracking-[0.18em]">For AI agents</p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="font-display mt-3 max-w-3xl text-4xl font-semibold tracking-tight md:text-5xl">
            Any AI agent. <span className="text-primary">One MCP server.</span>
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="text-muted-foreground mt-5 max-w-2xl leading-relaxed">
            Drop SendFast into Claude Desktop, Cursor, your custom LangChain agent — anywhere that
            speaks MCP. Five tools, native streaming, no glue code.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-6" delay={120}>
            <CodeBlock code={MCP_SNIPPET} language="json" label="claude_desktop_config.json" />
            <p className="text-muted-foreground mt-3 text-xs">
              Drop this into your client's MCP config. We handle the rest.
            </p>
          </Reveal>

          <div className="grid gap-3 lg:col-span-6">
            {TOOLS.map((t, i) => (
              <Reveal key={t.name} delay={140 + i * 60}>
                <Card className="flex flex-row items-start gap-4 p-4">
                  <code className="bg-muted whitespace-nowrap rounded-md px-2 py-1 font-mono text-xs">
                    {t.name}
                  </code>
                  <span className="text-foreground/90 text-sm leading-relaxed">{t.desc}</span>
                </Card>
              </Reveal>
            ))}
            <Reveal delay={140 + TOOLS.length * 60}>
              <Link
                to="/docs#mcp"
                className="text-muted-foreground hover:text-primary mt-1 inline-flex items-center text-sm transition"
              >
                Read the MCP docs →
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
